import RadioOption from "./components/RadioOption";
import React, { Fragment } from "react";
import "./index.css";

export default function RadioGroup({
  title,
  selectedOption,
  options,
  hex,
  onClick,
  disabled,
}) {
  return (
    <div className={`radio-group ${disabled ? "radio-group--disabled" : ""}`}>
      <h3 className="radio-group__title">{title}</h3>
      <div className="radio-group__container">
        {options.map((option, i) => (
          <Fragment key={i}>
            <RadioOption
              option={option}
              checked={option.value === selectedOption.value}
              onClick={onClick}
              hex={hex}
              disabled={disabled}
            />
          </Fragment>
        ))}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/components/RadioGroup/index.js